// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slider__item[data-v-4b43583c]{height:500px}[data-v-4b43583c] .slick-dots{bottom:15px}[data-v-4b43583c] .slick-dots li button:before{color:#fff;font-size:12px}[data-v-4b43583c] .slick-dots li.slick-active button{color:#fff}[data-v-4b43583c] .slick-dots li.slick-active button:before{color:#fff}[data-v-4b43583c] .slick-current{z-index:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
